// Firebase Configuration - Development Environment (pupzik)
// Project ID: guyapp-9bbed
// Domain: pupzik.com

export const firebaseConfig = {
  apiKey: "AIzaSyB2Sf2IvoHZGw77Q5w3O1-jeWjx3ZWc-VQ",
  authDomain: "guyapp-9bbed.firebaseapp.com",
  projectId: "guyapp-9bbed",
  storageBucket: "guyapp-9bbed.firebasestorage.app",
  messagingSenderId: "676734949963",
  appId: "1:676734949963:web:d96d62fc696e0d663e4bce",
  measurementId: "G-RL5KJBR6HL"
};
